<p>deal-analytics works!</p>
